import { Module } from 'vuex-smart-module';
import CompaniesUsersActions from './actions';
import CompaniesUsersGetters from './getters';
import CompaniesUsersMutations from './mutations';
import CompaniesUsersState from './state';
import CompaniesUsersManagers from './modules/managers';
import CompanyUserStaff from './modules/staff';

export default new Module({
  state: CompaniesUsersState,
  mutations: CompaniesUsersMutations,
  actions: CompaniesUsersActions,
  getters: CompaniesUsersGetters,
  modules: {
    companies_users_managers: CompaniesUsersManagers,
    company_user_staff: CompanyUserStaff,
  },
});
